/* eslint-disable camelcase */
import { roundedToFixed } from '../../../utils/number';

export default function spViewItem({ item_name, item_id, item_brand, item_parent_reporting_category, item_child_reporting_category, price }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_view_item',
        ecommerce: {
            items: [
                {
                    item_name,
                    item_id: item_id.toString(),
                    item_brand,
                    item_parent_reporting_category,
                    item_child_reporting_category,
                    price: roundedToFixed(parseFloat(price), 2),
                }
            ]
        }
    });
}